import { usdFormat } from "../../../../utils";
import { CommissaryOrder } from "../../../../types/order-commissary";

export const usd = (cents: number) => usdFormat.format((cents ?? 0) / 100);

export const formatStatus = (status: string) =>
  status
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

export interface CommissaryVendorGroup {
  vendorId: number;
  vendorName: string;
  pocName: string;
  pocPhone: string;
  orders: CommissaryOrder[];
  orderCount: number;
  totalSubtotal: number;
  totalTax: number;
  totalTotal: number;
}

export const groupOrdersByVendor = (
  orders: CommissaryOrder[]
): CommissaryVendorGroup[] => {
  const map: Record<number, CommissaryVendorGroup> = {};

  for (const order of orders) {
    const vendorId = order.vendor_id;
    if (!map[vendorId]) {
      map[vendorId] = {
        vendorId,
        vendorName: order.vendor?.name ?? "Unknown Vendor",
        pocName: order.vendor?.poc_name ?? "",
        pocPhone: order.vendor?.poc_phone ?? "",
        orders: [],
        orderCount: 0,
        totalSubtotal: 0,
        totalTax: 0,
        totalTotal: 0,
      };
    }
    const group = map[vendorId];
    group.orders.push(order);
    group.orderCount += 1;
    if (order.status === "fulfilled") {
      group.totalSubtotal += order.subtotal ?? 0;
      group.totalTax += order.tax ?? 0;
      group.totalTotal += order.total ?? 0;
    }
  }

  // Sort orders within each group by created_at desc
  Object.values(map).forEach((g) => {
    g.orders.sort((a, b) => (b.created_at ?? "").localeCompare(a.created_at ?? ""));
  });

  return Object.values(map).sort((a, b) =>
    a.vendorName.localeCompare(b.vendorName, undefined, { sensitivity: "base" })
  );
};
